import React from 'react';
import './styles/DesignerStyles.css';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { saveCookie } from './Utils';

import DesignerButton from './DesignerButton';

import createGameButtonIcon from './Images/CreateGamePaperIcon.svg';
import joinGameButtonIcon from './Images/JoinGamePaperIcon.svg';

import penClick from './Sounds/pen-click.wav';
class Home extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {};
  }

  componentDidMount() {
    if (!saveCookie(this.props) && !this.props.cookies.get('code')) {
      setTimeout(() => {
        this.props.navigate(`/LoginJustGoogle`);
      }, 1000);
    }
  }

  handleCreateRoom = () => {
    this.penClick.play();
    this.props.navigate(`/CreateGame`);

    this.forceUpdate();
  };

  handleJoinRoom = () => {
    this.penClick.play();
    this.props.navigate(`/JoinRoom`);

    this.forceUpdate();
  };

  render() {
    return (
      <div className="Home">
        <h1 className="H1Basic">Начална страница</h1>

        {/*this button will be brought back when we write the functionality*/}
        <DesignerButton
          style={{ position: 'absolute', right: '20px', top: '65px' }}
          class="questionButton"
          onClick={() => {
            this.penClick.play();
            this.props.navigate(`/Rules`);
          }}></DesignerButton>

        <div className="userProfileBackground">
          <DesignerButton
            style={{ position: 'absolute', left: '1.95px' }}
            class="userProfileButton"
            onClick={() => {
              this.penClick.play();
              this.props.navigate(`/Profile`);
            }}></DesignerButton>
        </div>

        {this.props.cookies.get('code') && (
          <div className="paperButtonsHolderDiv">
            <div>
              <button className="PaperButton" onClick={this.handleCreateRoom}>
                <div className="joinGameOuterDiv">
                  <img
                    src={createGameButtonIcon}
                    alt="create Game Button Text"
                  />
                  <b className="joinGameParagraph">Създай Игра</b>
                </div>
                <p>
                </p>
              </button>
            </div>

            <div>
              <button className="PaperButton" onClick={this.handleJoinRoom}>
                <div className="joinGameOuterDiv">
                  <img src={joinGameButtonIcon} alt="joinGameButtonText" />
                  <b className="joinGameParagraph">Влез в игра</b>
                </div>
                <p>
                </p>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withCookies(Home);
